import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

interface AuthenticatedRouteProps {
  children: React.ReactNode;
}

/**
 * AuthenticatedRoute component that only requires authentication and email verification
 * Does NOT require an organization - used for the NoOrganizationPage
 */
export default function AuthenticatedRoute({ children }: AuthenticatedRouteProps) {
  const { user, loading, emailVerified } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Check if email is verified
  if (!emailVerified) {
    return <Navigate to="/auth" replace />;
  }

  // If user has an organization, redirect them to the appropriate dashboard
  if (user.organizationId) {
    if (user.role === 'employee' && !user.employeeId) {
      // Pure employee without staff access
      return <Navigate to="/employee/dashboard" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
